import React from 'react';

import { BrowserRouter } from 'react-router-dom';

import { createRoot } from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';

import App from './App';
import './index.css';

// Eliminar la importación no utilizada
// import { RouterProvider } from './contexts/RouterContext';

// Asegurarse de que el elemento root existe
const rootElement = document.getElementById('root');

if (!rootElement) {
  // Reemplazamos console.error con un manejo silencioso
  document.body.innerHTML = `
    <div style="padding: 20px; text-align: center;">
      <h2>Error al inicializar la aplicación</h2>
      <p>No se pudo encontrar el elemento raíz. Por favor, intenta recargar la página.</p>
    </div>
  `;
} else {
  try {
    const root = createRoot(rootElement);

    root.render(
      <React.StrictMode>
        <HelmetProvider>
          <BrowserRouter>
            <App />
          </BrowserRouter>
        </HelmetProvider>
      </React.StrictMode>
    );
  } catch {
    // Reemplazamos console.error con un manejo silencioso
    rootElement.innerHTML = `
      <div style="padding: 20px; text-align: center;">
        <h2>Error al cargar la aplicación</h2>
        <p>Por favor, intenta recargar la página o contacta con soporte si el problema persiste.</p>
      </div>
    `;
  }
}
